<template>
  <header class="header-landing">
    <div class="container">
      <div class="header__wrap">
        <a href="/admin2/" class="main-nav__mobile">
          <i class="material-icons">
          input
        </i></a>
        <a href="/" class="header__logo">
          <img :src="`${publicPath}images/logo.svg`" alt="logo">
        </a><router-link to="/register" class="header__link">
          Регистрация
        </router-link>
        <a href="/admin2/" class="header__link header__link--login">Вход</a>
        <button type="button" :class="{'header__menu': true, 'is-active': activeMenu}" v-on:click="activeMenu = !activeMenu"></button>
      </div>
      <a class="header-landing__phone-number main-nav__mobile" href="tel:+74996776536">
        <i class="material-icons phone-icon">local_phone</i><span>+7 499 677 65 36</span>
      </a>
    </div>
    <nav class="main-nav" :class="{'is-active': activeMenu}">
      <div class="container">
        <div class="main-nav__wrap">
          <div class="main-nav__col">
            <h2 class="main-nav__title" v-on:click="openSubItem($event)">Отдел и продукты</h2>
            <div class="main-nav__list">
              <a href="#products-anchor" class="main-nav__link">Онлайн запись</a>
              <a href="#products-anchor" class="main-nav__link">Электронный журнал</a>
              <a href="#products-anchor" class="main-nav__link">SM&Co оповещения/E-mail оповещения</a>
              <a href="#" class="main-nav__link">Статистика и аналитика</a>
              <a href="#" class="main-nav__link">Клиентская база</a>
              <a href="#about-anchor" class="main-nav__link">Нужен ли мне Croinc?</a>
            </div>
          </div>
          <div class="main-nav__col">
            <h2 class="main-nav__title" v-on:click="openSubItem($event)">Цены</h2>
            <div class="main-nav__list">
              <!--               <a href="#" class="main-nav__link">Настроить тариф</a>-->
              <a href="#rates-anchor" class="main-nav__link">Выбрать тариф</a>
            </div>
          </div>
          <div class="main-nav__col">
            <h2 class="main-nav__title" v-on:click="openSubItem($event)">О компании</h2>
            <div class="main-nav__list">
              <a href="#" class="main-nav__link">Контакты</a>
            </div>
          </div>
          <div class="main-nav__col">
            <h2 class="main-nav__title" v-on:click="openSubItem($event)">Авторизация</h2>
            <div class="main-nav__list">
              <a href="/admin2/" class="main-nav__link">Вход</a>
              <router-link to="/register" class="main-nav__link">
                Регистрация
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </nav>
  </header>
</template>

<script>
  export default {
    name: "landingHeader",
    data() {
      return {
        activeMenu: false,
        publicPath: process.env.BASE_URL
      }
    },
    methods: {
      openSubItem(e) {
        let isActive = [...e.target.classList].includes('is-active');
        !isActive  ? e.target.classList.add('is-active') : e.target.classList.remove('is-active');
      }
    },
    mounted() {
      document.querySelectorAll('.main-nav__link').forEach((e) => {
        e.onclick = (() => {
          this.activeMenu = false;
        });
      });
    }
  }
</script>

<style scoped>

</style>
